
import React, { useState } from "react"
import { Bounce, toast } from "react-toastify"
import OrganizationAxiosInstance from "../Services/OrganizationAxiosInstance"
import { useParams } from "react-router-dom"
import { isAxiosError } from "axios"
import { useTranslation } from "react-i18next";


const SendNotification:React.FC = ()=>{

    const {id} = useParams<{id:string}>()
    const [message,setMessage] = useState<string>("")
    const {t} = useTranslation()

    const sendMessage = async ()=>{
        const toastId  = toast.loading("💌 Sending Message",{
          position: "top-right",
          theme: "light",
          isLoading:true,
          transition: Bounce
        })
        try {
          const response = await OrganizationAxiosInstance.post(`/PassTemplate/${id}/SendNotification/${message}`)
          if(response.status==200){
            toast.update(toastId, {
              render: "👌 message sent successfully",
              type: "success",
              isLoading: false,
              autoClose:3000
          })

          }
        } catch (error) {
            if(isAxiosError(error)){
              toast.update(toastId, {
                render: error.response?.data.error,
                type: "error",
                isLoading: false,
                autoClose:3000
            })
            }
        }finally{
          setMessage("")
        }
      }

    return  <div className="mt-4 p-3 flex flex-col items-center">
    <h4 className=" text-center my-3 font-bold text-l text-wrap">{t("sendNotification")}</h4>
      <textarea onChange={(e)=>{setMessage(e.target.value)}} value={message}  rows={4} className="w-[350px] block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 -gray-700 -gray-600 placeholder-gray-400 -white focus:ring-blue-500 focus:border-blue-500" placeholder={t("yourMessage")}></textarea>
      <button onClick={sendMessage} disabled={message==""?true:false} className=" mt-2 w-[200px] m-1 items-center px-4 py-2 text-xs  font-medium text-center text-white bg-brand-700 rounded-lg hover:bg-brand-600 focus:ring-4 focus:outline-none focus:ring-blue-300 -blue-600 hover:bg-blue-700 focus:ring-blue-800">
          {t("sendNotification")}
      </button>
                            
    </div>
}


export default SendNotification
